import React from 'react';
import './Spinner.css';

const Spinner: React.FC = () => {
  return <span className="overlay-loader"></span>;
}

export default Spinner;
